module.exports = __webpack_public_path__ + "static/react-logo-d02d8ca65ed7cf727a7e21221adcf8ff.png";